export default __webpack_public_path__ + "static/media/black_logo-transparent_bg.5475a3fe.png";